module.exports = __webpack_public_path__ + "6aa454847a05a66f2637584c8c7a95ce.png";